export const pluralizeString = (value: string, count: number) =>
  `${value}${count <= 1 ? '' : 's'}`;
